export const About = () => {
  return (
    <div>
      Gerador de Propostas - Solar Mais
    </div>
  );
}